import React from 'react';
import { NpsCsatSummary } from 'redux/schemas/app/analytics';
import NpsCsatStatWrapper from './nps-csat-stat-wrapper';
import NpsCsatScore from './nps-csat-score';
import NpsScale from './nps-scale';
import CsatScale from './csat-scale';

const NpsCsat = ({ npsCsatSummary }: { npsCsatSummary: NpsCsatSummary }) => (
  <div>
    {npsCsatSummary.nps && (
      <div className='mt-5'>
        <NpsCsatStatWrapper>
          <NpsCsatScore score={npsCsatSummary.nps.score} componentType='nps' />
          <NpsScale
            distribution={npsCsatSummary.nps.distribution}
            question={npsCsatSummary.nps.question.questionText}
          />
        </NpsCsatStatWrapper>
      </div>
    )}
    {npsCsatSummary.csat && (
      <div className='mt-5'>
        <NpsCsatStatWrapper>
          <NpsCsatScore score={npsCsatSummary.csat.score} componentType='csat' />
          <CsatScale
            distribution={npsCsatSummary.csat.distribution}
            question={npsCsatSummary.csat.question.questionText}
          />
        </NpsCsatStatWrapper>
      </div>
    )}
  </div>
);

export default NpsCsat;
